import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/swastishanti-staging/frontend-nextjs/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/ErrorBoundaryWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/NewsletterPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/PWASetup.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/RightPanelContent.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/components/StructuredData.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/swastishanti-staging/frontend-nextjs/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-poppins\",\"preload\":true,\"fallback\":[\"system-ui\",\"arial\"]}],\"variableName\":\"poppins\"}");
